import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ConfirmPlanProFeatureDialog } from '@frontend/components/Dialogs/ConfirmPlanProFeatureDialog';
import { priceNumber } from '@frontend/utils/priceNumber';
import { setupNetwork } from '@frontend/utils/wallet';
import { backendUrl, proPlans } from '@jdiyield/constants';
import { api } from '@jdiyield/utils';
import { useWeb3React } from '@web3-react/core';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useAccountContext } from '../AccountProvider';
import { useWalletConfig } from '../WalletConfigProvider';
var initialState = {
  loading: false,
  isApproved: false,
  isOpenPopupConfirm: false,
  confirmPlanProFeature: function confirmPlanProFeature() {
    return null;
  },
  onUnsubscribe: function onUnsubscribe() {
    return null;
  },
  approveProContract: function approveProContract() {
    return null;
  },
  cancelSelectPlan: function cancelSelectPlan() {
    return null;
  },
  plans: proPlans
};
var ProFeature = /*#__PURE__*/createContext(_objectSpread({}, initialState));
export var useChoosingPro = function useChoosingPro() {
  return useContext(ProFeature);
};
export var ChoosingProProvider = function ChoosingProProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(true),
      isOpenPopupConfirm = _useState[0],
      setIsOpenPopupConfirm = _useState[1];

  var _useState2 = useState(),
      selectedPlanId = _useState2[0],
      setSelectedPlanId = _useState2[1];

  var _useState3 = useState(false),
      isApproved = _useState3[0],
      setIsApproved = _useState3[1];

  var _useState4 = useState(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useWeb3React = useWeb3React(),
      library = _useWeb3React.library,
      account = _useWeb3React.account,
      chainId = _useWeb3React.chainId,
      active = _useWeb3React.active;

  var _useWalletConfig = useWalletConfig(),
      refetchRate = _useWalletConfig.refetchRate,
      myJdi = _useWalletConfig.myJdi;

  var _useAccountContext = useAccountContext(),
      onConnect = _useAccountContext.onConnect;

  useEffect(function () {
    ;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$import, bep20, contract, _isApproved;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(library && account && chainId === +process.env.NEXT_PUBLIC_MAIN_CHAIN_ID)) {
                _context.next = 13;
                break;
              }

              _context.next = 3;
              return import('@jdiyield/abi');

            case 3:
              _yield$import = _context.sent;
              bep20 = _yield$import.bep20;
              contract = new library.eth.Contract(bep20, process.env.NEXT_PUBLIC_JDI_TOKEN);
              _context.next = 8;
              return contract.methods.allowance(account, process.env.NEXT_PUBLIC_PRO_CONTRACT).call();

            case 8:
              _context.t0 = +_context.sent;
              _isApproved = _context.t0 !== 0;
              setIsApproved(_isApproved);
              _context.next = 14;
              break;

            case 13:
              setIsApproved(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [account, chainId, library]);
  var buttonContent = useMemo(function () {
    if (!active) return 'Connect Wallet';else if (chainId !== +process.env.NEXT_PUBLIC_MAIN_CHAIN_ID) return 'Change Network';else if (!isApproved) return "Approve JDI";else if (!selectedPlanId && selectedPlanId !== 0) return 'Select Plan';else {
      var findSelectedPlan = proPlans.find(function (plan) {
        return plan.id === selectedPlanId;
      });

      if (findSelectedPlan) {
        return "".concat(findSelectedPlan.id === 2 ? 'Stake' : 'Pay', " ").concat(priceNumber(findSelectedPlan === null || findSelectedPlan === void 0 ? void 0 : findSelectedPlan.pricing, {
          decimals: 0
        }), " JDI"); // return `Approve (${findSelectedPlan?.title} - ${priceNumber(findSelectedPlan?.pricing, { decimals: 0 })} JDI)`
      } else {
        return 'ERROR';
      }
    }
  }, [active, chainId, isApproved, selectedPlanId]);
  var approveProContract = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$import2, approveContract, approved;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            _context2.next = 3;
            return import('@jdiyield/contracts');

          case 3:
            _yield$import2 = _context2.sent;
            approveContract = _yield$import2.approveContract;
            _context2.next = 7;
            return approveContract(library, process.env.NEXT_PUBLIC_JDI_TOKEN, process.env.NEXT_PUBLIC_PRO_CONTRACT, account);

          case 7:
            approved = _context2.sent;
            setIsApproved(approved);
            setLoading(false);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [account, library]);
  var handleConfirm = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _yield$import3, registerProFeature, isSubscribed;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (active) {
              _context3.next = 4;
              break;
            }

            onConnect();
            _context3.next = 30;
            break;

          case 4:
            if (!(chainId !== +process.env.NEXT_PUBLIC_MAIN_CHAIN_ID)) {
              _context3.next = 9;
              break;
            }

            _context3.next = 7;
            return setupNetwork(+process.env.NEXT_PUBLIC_MAIN_CHAIN_ID);

          case 7:
            _context3.next = 30;
            break;

          case 9:
            if (isApproved) {
              _context3.next = 14;
              break;
            }

            approveProContract(); //TODO noti popup?

            return _context3.abrupt("return", null);

          case 14:
            if (!(!selectedPlanId && selectedPlanId !== 0)) {
              _context3.next = 18;
              break;
            }

            return _context3.abrupt("return", null);

          case 18:
            setLoading(true);
            _context3.next = 21;
            return import('@jdiyield/contracts');

          case 21:
            _yield$import3 = _context3.sent;
            registerProFeature = _yield$import3.registerProFeature;
            _context3.next = 25;
            return registerProFeature(library, selectedPlanId, account);

          case 25:
            isSubscribed = _context3.sent;
            isSubscribed && refetchRate();
            setLoading(false);
            cancelSelectPlan(); //TODO noti popup?

            return _context3.abrupt("return", null);

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [account, active, approveProContract, chainId, isApproved, library, onConnect, refetchRate, selectedPlanId]);

  var confirmPlanProFeature = function confirmPlanProFeature(planId) {
    setIsOpenPopupConfirm(true);
    setSelectedPlanId(planId);
  };

  var cancelSelectPlan = function cancelSelectPlan() {
    setIsOpenPopupConfirm(false);
  };

  var onUnsubscribe = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(link) {
      var _yield$import4, unSubscribeProFeature, isSusses;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              if (!(library && account)) {
                _context4.next = 14;
                break;
              }

              //
              setLoading(true);
              _context4.next = 5;
              return import('@jdiyield/contracts');

            case 5:
              _yield$import4 = _context4.sent;
              unSubscribeProFeature = _yield$import4.unSubscribeProFeature;
              _context4.next = 9;
              return unSubscribeProFeature(library, account);

            case 9:
              isSusses = _context4.sent;

              if (!(isSusses && link)) {
                _context4.next = 13;
                break;
              }

              _context4.next = 13;
              return api.post("".concat(backendUrl, "/subscriber/unsubscribe"), {
                link: link
              });

            case 13:
              refetchRate();

            case 14:
              _context4.next = 19;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](0);
              console.log('onUnsubscribe', _context4.t0);

            case 19:
              _context4.prev = 19;
              setLoading(false);
              return _context4.finish(19);

            case 22:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 16, 19, 22]]);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [account, library, refetchRate]);
  var disabledConfirm = useMemo(function () {
    if (active && isApproved && (selectedPlanId || selectedPlanId === 0)) {
      var findSelectedPlan = proPlans.find(function (plan) {
        return plan.id === selectedPlanId;
      });

      if (findSelectedPlan) {
        return myJdi < findSelectedPlan.pricing;
      }
    }

    return false;
  }, [active, isApproved, myJdi, selectedPlanId]);
  return _jsxs(ProFeature.Provider, {
    value: {
      loading: loading,
      isApproved: isApproved,
      isOpenPopupConfirm: isOpenPopupConfirm,
      confirmPlanProFeature: confirmPlanProFeature,
      approveProContract: approveProContract,
      onUnsubscribe: onUnsubscribe,
      cancelSelectPlan: cancelSelectPlan,
      plans: proPlans
    },
    children: [_jsx(ConfirmPlanProFeatureDialog, {
      loading: loading,
      id: selectedPlanId,
      open: isOpenPopupConfirm,
      onClose: cancelSelectPlan,
      onConfirm: handleConfirm,
      plans: proPlans,
      submitContent: buttonContent,
      disabledConfirm: disabledConfirm
    }), children]
  });
};